module.exports = __webpack_public_path__ + "img/orange_129.9d5d05b9.png";